/**
 * Разбор результата занятия.
 *
 * Итог относится к токенам пакета: во фрагменте `a != b` набираются и буквы,
 * но `!=` — это то, ради чего фрагмент показан, а буквы тренирует другой
 * режим. Разбор идёт по вхождениям токена, а не по элементам упражнения: в
 * одном элементе токенов бывает несколько, и общий итог по строке не сказал
 * бы, какое сочетание не даётся.
 */

import type {
  KeystrokeEvent,
  MasteryStat,
  MasteryUnit,
  TypingError,
  UnitOutcome,
} from '@type2x/shared-contracts';
import { toMasteryUnitId } from '@type2x/shared-contracts';
import { collectTokenOutcomes, findTokenSpans } from '@type2x/typing-engine';
import { applyUnitOutcomes, type LearningConfig } from '@type2x/learning-engine';

import type { PacksPlan } from '../contracts/packs.js';
import { packUnitId } from './groups.js';

/** Сопоставляет нажатия токенам режима. */
export function collectPackOutcomes(
  plan: PacksPlan,
  events: readonly KeystrokeEvent[],
  errors: readonly TypingError[],
): UnitOutcome[] {
  const spans = findTokenSpans(plan.exercise.text, plan.unlockedTokens);

  return collectTokenOutcomes(spans, events, errors).map((outcome) => ({
    unitId: toMasteryUnitId(packUnitId(outcome.token)),
    attempts: outcome.attempts,
    errors: outcome.errors,
    medianLatencyMs: outcome.medianLatencyMs,
    corrections: outcome.corrections,
  }));
}

/** Обновляет статистику токенов по итогам занятия. */
export function applyPackOutcomes(
  units: readonly MasteryUnit[],
  stats: Readonly<Record<string, MasteryStat>>,
  outcomes: readonly UnitOutcome[],
  config: LearningConfig,
  nowIso: string,
): MasteryStat[] {
  return applyUnitOutcomes(units, stats, outcomes, config, nowIso);
}
